export default __webpack_public_path__ + "pdf/Fiona_Naughton.fe8eeb8.pdf";